"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyCode_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyCode_Factory = /** @class */ (function () {
    function WasfatyCode_Factory() {
    }
    WasfatyCode_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AuthorityCode: model.AuthorityCode,
            Division: model.Division,
            DosageForm: model.DosageForm,
            DosageFormCode: model.DosageFormCode,
            DosageOrderForm: model.DosageOrderForm,
            DosageUnit: model.DosageUnit,
            DosageUnitId: model.DosageUnitId,
            DoseStrength: model.DoseStrength,
            DoseStrengthUnitId: model.DoseStrengthUnitId,
            EnableInstructions: model.EnableInstructions,
            Flex: model.Flex,
            GenericCode: model.GenericCode,
            GenericDisplayName: model.GenericDisplayName,
            GenericName: model.GenericName,
            Ingredients: model.Ingredients,
            IsActive: model.IsActive,
            IsAlternative: model.IsAlternative,
            IsDelivery: model.IsDelivery,
            IsDivisible: model.IsDivisible,
            IsDivisibleFactor: model.IsDivisibleFactor,
            IsHazardous: model.IsHazardous,
            IsHighAlert: model.IsHighAlert,
            IsInfiniteDivisible: model.IsInfiniteDivisible,
            IsLasa: model.IsLasa,
            ItemId: model.ItemId,
            LocalGenericCode: model.LocalGenericCode,
            MainRoaCode: model.MainRoaCode,
            MaxDailyDose: model.MaxDailyDose,
            MaxDuration: model.MaxDuration,
            MaxRefill: model.MaxRefill,
            Region: model.Region,
            RequiresApprove: model.RequiresApprove,
            RoaCode: model.RoaCode,
            RouteOfAdmin: model.RouteOfAdmin,
            Strength: model.Strength,
            SuggestedRouteOfAdmin: model.SuggestedRouteOfAdmin,
            UnitType: model.UnitType,
            UnitTypeId: model.UnitTypeId,
            UpdatedDate: Date_Factory_1.Date_Factory.CreateIncoming(model.UpdatedDate),
            VerbDescription: model.VerbDescription,
            VerbSecondLanguageDescription: model.VerbSecondLanguageDescription,
            Version: model.Version,
            Volume: model.Volume,
            VolumeUnit: model.VolumeUnit,
            VolumeUnitId: model.VolumeUnitId,
            WasfatyId: model.WasfatyId,
            WasfatyListId: model.WasfatyListId,
        };
        return result;
    };
    WasfatyCode_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AuthorityCode: model.AuthorityCode,
            Division: model.Division,
            DosageForm: model.DosageForm,
            DosageFormCode: model.DosageFormCode,
            DosageOrderForm: model.DosageOrderForm,
            DosageUnit: model.DosageUnit,
            DosageUnitId: model.DosageUnitId,
            DoseStrength: model.DoseStrength,
            DoseStrengthUnitId: model.DoseStrengthUnitId,
            EnableInstructions: model.EnableInstructions,
            Flex: model.Flex,
            GenericCode: model.GenericCode,
            GenericDisplayName: model.GenericDisplayName,
            GenericName: model.GenericName,
            Ingredients: model.Ingredients,
            IsActive: model.IsActive,
            IsAlternative: model.IsAlternative,
            IsDelivery: model.IsDelivery,
            IsDivisible: model.IsDivisible,
            IsDivisibleFactor: model.IsDivisibleFactor,
            IsHazardous: model.IsHazardous,
            IsHighAlert: model.IsHighAlert,
            IsInfiniteDivisible: model.IsInfiniteDivisible,
            IsLasa: model.IsLasa,
            ItemId: model.ItemId,
            LocalGenericCode: model.LocalGenericCode,
            MainRoaCode: model.MainRoaCode,
            MaxDailyDose: model.MaxDailyDose,
            MaxDuration: model.MaxDuration,
            MaxRefill: model.MaxRefill,
            Region: model.Region,
            RequiresApprove: model.RequiresApprove,
            RoaCode: model.RoaCode,
            RouteOfAdmin: model.RouteOfAdmin,
            Strength: model.Strength,
            SuggestedRouteOfAdmin: model.SuggestedRouteOfAdmin,
            UnitType: model.UnitType,
            UnitTypeId: model.UnitTypeId,
            UpdatedDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.UpdatedDate),
            VerbDescription: model.VerbDescription,
            VerbSecondLanguageDescription: model.VerbSecondLanguageDescription,
            Version: model.Version,
            Volume: model.Volume,
            VolumeUnit: model.VolumeUnit,
            VolumeUnitId: model.VolumeUnitId,
            WasfatyId: model.WasfatyId,
            WasfatyListId: model.WasfatyListId,
        };
        return result;
    };
    return WasfatyCode_Factory;
}());
exports.WasfatyCode_Factory = WasfatyCode_Factory;
